import { cdnClient } from '../../../../api-clients/cdn/client';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { browsingDomainStore } from '../../store';
export const loadTrailerUrlForFilm = async (film, reloadCachedData = false) => {
    const state = createOrGetFetchedState(browsingDomainStore.data.trailerUrlsByFilmId, film.id);
    await loadDataFromApi({
        api: () => getFilmTrailerUrl(film),
        state,
        cacheDuration: getCacheDuration('films'),
        reloadCachedData
    });
};
const getFilmTrailerUrl = async (film) => {
    const url = cdnClient.instance.film(film).trailer();
    const isTrailerAvailable = await cdnClient.instance.isCdnMediaAvailable(url);
    return isTrailerAvailable ? url : undefined;
};
